import { Insurance, Order, Plan } from "cw-backend";

export class OrderPatientDetail {
    id?: number;
    order?: Order;
    insurance: Insurance;
    plan: Plan;
    holder: string;
    product: string;
    validity: Date;
    enrollment: string;
}